module.exports = __webpack_public_path__ + "img/item-2.8a3bb67.png";